import { useState } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { useNavigate } from "react-router";
import ImageModal from "../../orders/ServiceOrders/images/modal";
function BookingInfo({ orders, orderstatusformatter, dateformatter, id }) {
    const [Images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const Navigate = useNavigate();
    console.log(id);
    return (
        <>
            {isOpen && (
                <ImageModal
                    images={[...Images]}
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                />
            )}
            <button
                className={dashboardclasses["backbutton"]}
                onClick={() => {
                    Navigate(-1);
                }}>
                Back
            </button>
            <header className={dashboardclasses["order-details-header"]}>
                <h3
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                    }}>
                    Booking Details{" "}
                    {orderstatusformatter(orders?.booking_status)}
                </h3>
                <div className={dashboardclasses["order-header-item"]}>
                    <h5>Booking ID</h5>

                    <p>#{orders.booking_id}</p>
                </div>
                <div className={dashboardclasses["order-header-item"]}>
                    <h5>BOOKING DATE TIME</h5>

                    {dateformatter(orders.book_date)}
                </div>
            </header>
            <div className={dashboardclasses["orders-form-invoice-wrapper"]}>
                <div className={dashboardclasses["orders-form-invoice"]}>
                    {/*   <div
                                            className={
                                                dashboardclasses[
                                                    "invoice-detail"
                                                ]
                                            }>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "detail-status"
                                                    ]
                                                }>
                                                <span>Status:</span>
                                                {orders?.status !=
                                                    "AdminCanceled" &&
                                                orders?.status !=
                                                    "UserCanceled" &&
                                                orders?.status != "Delivered" &&
                                                orders.status !=
                                                    "Payment-Failed" ? (
                                                    <select
                                                        defaultValue={
                                                            orders.orderStatus
                                                        }
                                                        onChange={
                                                            statuschangehandler
                                                        }>
                                                        {" "}
                                                        <option
                                                            value=""
                                                            default>
                                                            Update status
                                                        </option>
                                                    
                                                        <option value="Delivered">
                                                            Delivered{" "}
                                                        </option>
                                                        <option value="AdminCanceled">
                                                            Admin Cancel{" "}
                                                        </option>
                                                    </select>
                                                ) : (
                                                    orderstatusformatter(
                                                        orders.status
                                                    )
                                                )}
                                            </div>
                                            {orders?.status ==
                                                "Payment-Success" && (
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-handler"
                                                        ]
                                                    }>
                                                    <span>Update Vendor:</span>
                                                    <select
                                                        name=""
                                                        id=""
                                                        style={{
                                                            height: "2rem",
                                                            border: "1px solid #ccc",
                                                        }}
                                                        defaultValue={""}
                                                        onChange={
                                                            changeHandler
                                                        }>
                                                        <option
                                                            value=""
                                                            disabled>
                                                            Update Vendor
                                                        </option>
                                                        {allVendorData?.map(
                                                            (item) => (
                                                                <option
                                                                    value={
                                                                        item.mobile
                                                                    }>
                                                                    {item.name}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div> */}

                    <div className={dashboardclasses["order-items"]}>
                        <header
                            className={
                                dashboardclasses["customer-info-header"]
                            }>
                            <h4>Customer Info</h4>
                        </header>

                        <div>
                            <div
                                className={dashboardclasses["order-item-data"]}>
                                <div className={dashboardclasses["order-date"]}>
                                    <h5>Name</h5>
                                    <h4>:</h4>
                                    <p>{orders.name}</p>
                                </div>

                                <div className={dashboardclasses["order-date"]}>
                                    <h5>Contact Number</h5>
                                    <h4>:</h4>
                                    <p>{orders.user_mobile}</p>
                                </div>
                                {/* <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>shop</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.shop}</p>
                                                    </div> */}
                            </div>
                        </div>
                        <div className={dashboardclasses["order-item-data"]}>
                            <h4> Service Details</h4>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Pickup Location</h5>
                                <h4>:</h4>
                                <p>
                                    {orders?.main_pickup_address?.buildingName},
                                    {orders?.main_pickup_address?.areaName}
                                    <br />
                                    {orders?.main_pickup_address?.city},
                                    {orders?.main_pickup_address?.state}-
                                    {orders?.main_pickup_address?.pincode}
                                </p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Drop Location</h5>
                                <h4>:</h4>
                                <p>
                                    {orders?.main_drop_address?.buildingName},
                                    {orders?.main_drop_address?.areaName}
                                    <br />
                                    {orders?.main_drop_address?.city},
                                    {orders?.main_drop_address?.state}-
                                    {orders?.main_drop_address?.pincode}
                                </p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Start Time</h5>
                                <h4>:</h4>
                                <p>{orders?.start_time_formatted}</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>End Time</h5>
                                <h4>:</h4>
                                <p>{orders?.end_time_formatted}</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Distance</h5>
                                <h4>:</h4>
                                <p>{orders?.distance}KM</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Time</h5>
                                <h4>:</h4>
                                <p>{orders?.service_time} M</p>
                            </div>
                            {orders?.booking_status == 4 && (
                                <div
                                    className={
                                        dashboardclasses["order-date-address"]
                                    }>
                                    <h5>Cancel Reason</h5>
                                    <h4>:</h4>
                                    <p>{orders?.cancel_reason} M</p>
                                </div>
                            )}
                        </div>
                        <div className={dashboardclasses["order-item-data"]}>
                            <h4>Vehicle Details</h4>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Name</h5>
                                <h4>:</h4>
                                <p>{orders?.driver_name}</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Mobile</h5>
                                <h4>:</h4>
                                <p>{orders?.driver_mobile}</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Transport</h5>
                                <h4>:</h4>
                                <p>{orders?.transport_name}</p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Price Per KM</h5>
                                <h4>:</h4>
                                <p>{orders?.price_per_km}/-</p>
                            </div>
                        </div>
                        <div className={dashboardclasses["order-item-data"]}>
                            <h4>Booking images</h4>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Before</h5>
                                <h4>:</h4>
                                {orders?.before_booking_images &&
                                orders?.before_booking_images?.length > 0 ? (
                                    <button
                                        onClick={() => {
                                            setIsOpen(true);
                                            setImages(
                                                orders?.before_booking_images
                                            );
                                        }}
                                        style={{
                                            width: "100px",
                                            border: "none",
                                            textDecoration: "underline",
                                            backgroundColor: "inherit",
                                            borderRadius: "10px",
                                        }}>
                                        View
                                    </button>
                                ) : (
                                    <p>NA</p>
                                )}
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>After</h5>
                                <h4>:</h4>
                                {orders?.after_booking_images &&
                                orders?.after_booking_images ? (
                                    <button
                                        onClick={() => {
                                            setIsOpen(true);
                                            setImages(
                                                orders?.after_booking_images
                                            );
                                        }}
                                        style={{
                                            width: "100px",
                                            border: "none",
                                            textDecoration: "underline",
                                            backgroundColor: "inherit",
                                            borderRadius: "10px",
                                        }}>
                                        View
                                    </button>
                                ) : (
                                    <p>NA</p>
                                )}
                            </div>
                        </div>
                        {orders?.booking_status == 2 && (
                            <div
                                className={dashboardclasses["order-item-data"]}>
                                <h4>Tracking Details</h4>
                                <div style={{ width: "70vw", height: "60vh" }}>
                                    <iframe
                                        src={`${process.env.REACT_APP_BASE_URL_TRACKING}/?bookingID=${id}`}
                                        title="Live Tracking"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            border: "none",
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div className={dashboardclasses["order-item-data"]}>
                            <h4> Payment Details </h4>

                            <div className={dashboardclasses["order-date"]}>
                                <h5>Payment Type </h5>
                                <h4>:</h4>
                                <p>
                                    {orders.payment_method == 1
                                        ? "COD"
                                        : orders.payment_method == 2
                                        ? "ONLINE"
                                        : "Wallet"}
                                </p>
                            </div>
                            <div className={dashboardclasses["order-date"]}>
                                <h5>Ride Fare</h5>
                                <h4>:</h4>
                                <p>₹ {orders.ride_fare}</p>
                            </div>
                            <div className={dashboardclasses["order-date"]}>
                                <h5>Night Charges</h5>
                                <h4>:</h4>
                                <p>₹ {orders.night_charges}</p>
                            </div>
                            <div className={dashboardclasses["order-date"]}>
                                <h5>Waiting Charges</h5>
                                <h4>:</h4>
                                <p>₹ {orders.waiting_charges}</p>
                            </div>
                            <div className={dashboardclasses["order-date"]}>
                                <h5>Extra Charges</h5>
                                <h4>:</h4>
                                <p>₹ {orders.extra_charges}</p>
                            </div>
                            {orders?.is_coupon_applied == 1 && (
                                <div className={dashboardclasses["order-date"]}>
                                    <h5>Coupon Discount</h5>
                                    <h4>:</h4>
                                    <p>₹ {orders.coupon_discount}</p>
                                </div>
                            )}

                            <div className={dashboardclasses["order-date"]}>
                                <h5>Grand Total</h5>
                                <h4>:</h4>

                                <p>₹ {orders.grand_total}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BookingInfo;
